import React from "react";
import { Box, CircularProgress, Typography, BoxProps } from "@mui/material";

export interface LoadingSpinnerProps extends BoxProps {
  message?: string;
  size?: number;
  fullScreen?: boolean;
}

/**
 * Composant LoadingSpinner pour afficher un état de chargement
 *
 * @example
 * ```tsx
 * <LoadingSpinner />
 * <LoadingSpinner message="Chargement des données..." />
 * <LoadingSpinner fullScreen size={60} />
 * ```
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message,
  size = 40,
  fullScreen = false,
  sx,
  ...props
}) => {
  const content = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        ...sx,
      }}
      {...props}
    >
      <CircularProgress size={size} sx={{ color: "primary.main" }} />
      {message && (
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {message}
        </Typography>
      )}
    </Box>
  );

  if (fullScreen) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "background.default",
          zIndex: 9999,
        }}
      >
        {content}
      </Box>
    );
  }

  return content;
};
